import { getCO2AequivalentSubscope7, getCO2AequivalentSubscope69_Unterkunft } from '../getCO2Aequivalent';
import { getDataForKraftstoff } from './getDataForKraftstoff';
import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { IDs } from '../../../helpers/IDs';
import { getDatenqualitaet } from '../getDatenqualitaet';
import { makeSimpleKennzahl } from '../strukturiert/makeKennzahl';
import { Kennzahl } from '../strukturiert/Kennzahl';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';

export function processSubscope7(row: any, data: any, item: any, jahr: number, arr: any[]) {
    // console.log('SS7ARR', arr);
    if (row.parent_tid && row.parent_tid > 0) {
        return; // Das ist eine Entfernungs-Row, also raus
    }
    const key_wert = 'co2_fussabdruck_s3_ss7_wert';
    let faktor = null;
    // Lieferantenstrom abfangen
    if (
        row.transportmittel === 'e_bike'
        || ((row.transportmittell === 'krad' || row.transportmittell === 'pkw') && row.kraftstoff === 'strom')
    ) {
        // Wenn E-Bike oder Krad/PKW mit Strom
        if (row.strom === 'lieferant') {
            faktor = { name: 'Lieferantenstrom', wert: row.faktor_strom };
        }
    }
    // console.log('SS7 - IN: ', jahr, row, arr);
    // Konfig
    const co2_fussabdruck_ghg = (((data || {})[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_modus === 'ghg';
    const modus = row.modus;
    row = { ...row };
    let menge = 0;
    const subrows = arr.filter((sr: any) => sr.parent_tid === row.tid && sr.modus === modus);
    const fakt_hin_rueck = (+row.hin_rueck === 2 || +row.hin_rueck_orig === 2) ? 1 : 2;
    const arbeitstage = +row.arbeitstage || 200;
    const arr_datenqualitaet: any[] = [];

    if (!modus || modus === '0' || !co2_fussabdruck_ghg || modus === 'distance_based') {
        if (subrows.length > 0) {
            const names: any = {};
            subrows.forEach((sr: any) => {
                const faktor_entf = getCO2AequivalentSubscope7(data, jahr, sr);
                const value_entf = +sr.entfernung * fakt_hin_rueck * arbeitstage;
                menge += sr.entfernung;
                const sr_value = value_entf * faktor_entf.wert;
                if (row.value) {
                    row.value += sr_value;
                } else {
                    row.value = sr_value;
                }
                let subname = '';
                if (sr.transportmittel) {
                    subname = `${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', sr.transportmittel)}${sr.kraftstoff ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'kraftstoff', sr.kraftstoff)})` : ''}`;
                    names[subname] = true;
                }
                // console.log('SS7 KCZ SR', jahr + ' ' + row.tid + ' --> ', sr.entfernung + ' : ' + value_entf, sr , row);
                if (!row.quelle) {
                    row.quelle = faktor_entf.quelle;
                } else if (row.quelle.indexOf(faktor_entf.quelle) === -1) {
                    row.quelle += ';;' + faktor_entf.quelle;
                }
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                const faktor_info = (faktor_entf.transportmittel || sr.transportmittel) + '_' + (faktor_entf.kraftstoff || sr.kraftstoff);
                row.faktor_map[faktor_info] = {
                    info: subname,
                    menge: value_entf,
                    mengeOrig: +sr.entfernung,
                    menge_einheit: 'km',
                    menge_einheitOrig: 'km',
                    wert: faktor_entf.wert * 1000000,
                    einheit: 'gCO₂Äq/km',
                    quelle: faktor_entf.quelle,
                    formel_co2: 'co2_fahrt_arbeitstage',
                    faktoren: [
                        {
                            value: fakt_hin_rueck,
                            type: KennzahlFaktor.TYPE_FAHRT,
                            formel: 'menge_fahrt'
                        },
                        {
                            value: arbeitstage,
                            type: KennzahlFaktor.TYPE_ARBEITSTAGE,
                            formel: 'menge_fahrt_arbeitstage'
                        }
                    ]
                };
                arr_datenqualitaet.push({
                    wert: sr_value === 0 ? 0.1 : sr_value, // hier Emission t CO2 Äq.
                    emissionsfaktor: sr_value === 0 ? 1 : +faktor_entf.datenqualitaet,
                    bewertung: +row.bewertung_emissionsfaktor,
                    datenherkunft: +row.datenherkunft,
                    faktor_entf
                });
                makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss7_' + row.tid + '_' + sr.tid, jahr, row.standort_tid_orig, row.tid,
                    'Teilentfernung', subname, value_entf, sr_value, 'km',
                    faktor_entf.wert, faktor_entf.quelle, data);
            });
            row.faktor_einheit = 'gemischt';
            row.einheit = 'km';
            row.name = Object.keys(names).join('\n');
        } else {
            if (!faktor) {
                faktor = getCO2AequivalentSubscope7(data, jahr, row);
            }
            // console.log('Subscope 7 Faktor: ', faktor);
            menge = row.entfernung;
            row.faktor = faktor.wert * 1000000;
            row.faktor_einheit = 'gCO₂Äq/km';
            row.einheit = 'km';
            row.quelle = faktor.quelle;
            if ((row.tid + '').startsWith('kampagne_')) {
                // Datensätze aus ENT_CO2_SCOPE3_PENDELN_KAMPAGNE durch jsonToSubscope7()
                row.value = faktor.wert * +row.entfernung;
                row.name = `${row.mitarbeiter}: ${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', row.transportmittel)}${row.kraftstoff ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'kraftstoff', row.kraftstoff)})` : ''}`;
            } else {
                row.value = faktor.wert * +row.entfernung * fakt_hin_rueck * arbeitstage;
                row.name = `${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', row.transportmittel)}${row.kraftstoff ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'kraftstoff', row.kraftstoff)})` : ''}`;
                row.einheit = 'km';
                row.mengeOrig = row.entfernung;
                row.einheitOrig = 'km';
                row.faktor_einheit = 'gCO₂Äq/km';
                row.faktoren = [
                    {
                        value: fakt_hin_rueck,
                        type: KennzahlFaktor.TYPE_FAHRT,
                        formel: 'menge_fahrt'
                    },
                    {
                        value: arbeitstage,
                        type: KennzahlFaktor.TYPE_ARBEITSTAGE,
                        formel: 'menge_fahrt_arbeitstage'
                    }
                ];
            }

            arr_datenqualitaet.push({
                wert: row.value === 0 ? 0.1 : row.value, // hier Emission t CO2 Äq.
                emissionsfaktor: row.value === 0 ? 1 : +faktor.datenqualitaet,
                bewertung: +row.bewertung_emissionsfaktor,
                datenherkunft: +row.datenherkunft
            });
            makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss7_' + row.tid, jahr, row.standort_tid_orig, row.tid,
                'Entfernung', row.name, menge, row.value, row.einheit,
                row.faktor, row.quelle, data);
        }
        // menge = row.tid === -999
        menge = (row.tid || '').toString().startsWith('kampagne_') // Datensätze aus ENT_CO2_SCOPE3_PENDELN_KAMPAGNE durch jsonToSubscope7()
            ? menge : menge * fakt_hin_rueck * arbeitstage;
    } else if (modus === 'spend_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            const names: any = {};
            subrows.forEach((sr: any) => {
                const faktor_entf = getCO2AequivalentSubscope7(data, jahr, sr);
                const value_spend = +sr.kosten * faktor_entf.wert_euro;
                if (row.value) {
                    row.value += value_spend; // * +row.menge;
                    row.kosten += +sr.kosten;
                } else {
                    row.value = value_spend; // * +row.menge;
                    row.kosten = +sr.kosten;
                }
                if (sr.transportmittel) {
                    names[getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', sr.transportmittel)] = true;
                }
                // console.log('SS8 subrow: ', jahr, faktor_entf, sr.kosten, row.value, row);
                if (!row.quelle) {
                    row.quelle = faktor_entf.quelle;
                } else if (row.quelle.indexOf(faktor_entf.quelle) === -1) {
                    row.quelle += ';;' + faktor_entf.quelle;
                }

                arr_datenqualitaet.push({
                    wert: value_spend, // hier Emission t CO2 Äq.
                    emissionsfaktor: +faktor_entf.datenqualitaet,
                    bewertung: +row.bewertung_emissionsfaktor,
                    datenherkunft: +row.datenherkunft
                });
            });
            menge = row.kosten;
            row.faktor = (row.value / row.kosten) * 1000000;
            row.name = Object.keys(names).join('\n');
        } else {
            const faktor_entf = getCO2AequivalentSubscope7(data, jahr, row);
            const value_euro = (+row.kosten || 0) * (faktor_entf.wert_euro || 0);
            // console.log('SS6SB:', faktor_entf);
            row.value = value_euro;
            menge = row.kosten;
            row.faktor = faktor_entf.wert_euro * 1000000;
            row.quelle = faktor_entf.quelle;
            row.name = getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', row.transportmittel);
            arr_datenqualitaet.push({
                wert: value_euro,
                emissionsfaktor: +faktor_entf.datenqualitaet,
                bewertung: +row.bewertung_emissionsfaktor,
                datenherkunft: +row.datenherkunft,
                faktor_entf
            });
            makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss7_' + row.tid, jahr, row.standort_tid_orig, row.tid,
                'Kosten', row.name, menge, row.value, row.einheit,
                row.faktor, row.quelle, data);
        }
        row.einheit = '€';
        row.faktor_einheit = 'gCO₂Äq/€';
    } else if (modus === 'fuel_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            const names: any = {};
            let value = 0;
            subrows.forEach((sr: any) => {
                const fuel_item = getDataForKraftstoff(sr, jahr, data);
                if (row.verbrauch) {
                    row.verbrauch += sr.verbrauch;
                    row.value += fuel_item.co2 * (+row.arbeitstage || 200);
                } else {
                    row.verbrauch = sr.verbrauch;
                    row.value = fuel_item.co2 * (+row.arbeitstage || 200);
                }
                names[sr.energietraeger_tid] = true;
                if (!row.quelle) {
                    row.quelle = fuel_item.quelle;
                } else if (row.quelle.indexOf(fuel_item.quelle) === -1) {
                    row.quelle += ';;' + fuel_item.quelle;
                }
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                row.faktor_map[fuel_item.energietraeger] = {
                    info: sr.energietraeger_tid,
                    menge: +sr.verbrauch * (+sr.arbeitstage || 200),
                    menge_einheit: 'kWh',
                    menge_einheitOrig: fuel_item.einheit,
                    wert: fuel_item.faktor_co2 * 1000000,
                    quelle: fuel_item.quelle_co2,
                    einheit: 'gCO₂Äq/kWh',
                    wert_um: fuel_item.faktor_um,
                    einheit_um: `kWh/${fuel_item.einheit}`,
                    quelle_um: fuel_item.quelle_um,
                    wert_um_co2: fuel_item.faktor_um,
                    einheit_um_co2: `kWh/${fuel_item.einheit}`,
                    quelle_um_co2: fuel_item.quelle_um,
                };
                arr_datenqualitaet.push({
                    wert: fuel_item.co2, // hier Emission t CO2 Äq.
                    emissionsfaktor: +fuel_item.datenqualitaet_1, // Warum hier Scope 1 und nicht 3?
                    datenherkunft: +row.datenherkunft,
                    bewertung: +row.bewertung_emissionsfaktor
                });
                menge += sr.verbrauch * (+sr.arbeitstage || 200) * fuel_item.faktor_um;
                value += sr.verbrauch * (+sr.arbeitstage || 200) * fuel_item.faktor_um * fuel_item.faktor_co2;
            });
            row.name = Object.keys(names).join('\n');
            row.faktor_einheit = 'gCO₂Äq/kWh';
            row.menge = menge;
            row.value = value;
            row.einheit = 'kWh';
        } else {
            const fuel_item = getDataForKraftstoff(row, jahr, data);
            row.name = row.energietraeger_tid;
            // console.log('S7', row.arbeitstage, row);
            row.value = fuel_item.co2 * (+row.arbeitstage || 200);
            menge = row.verbrauch * (+row.arbeitstage || 200);
            row.einheit = fuel_item.einheit;
            row.faktor = fuel_item.faktor_co2 * 1000000;
            row.faktor_einheit = 'gCO₂Äq/' + fuel_item.einheit;
            row.quelle = fuel_item.quelle_co2;
            arr_datenqualitaet.push({
                // wert: +row.menge,
                wert: fuel_item.co2, // hier Emission t CO2 Äq.
                emissionsfaktor: +fuel_item.datenqualitaet_1, // Warum hier Scope 1 und nicht 3?
                datenherkunft: +row.datenherkunft,
                bewertung: +row.bewertung_emissionsfaktor
            });
        }
    } else if (modus === 'user_specific') {
        row.name = row.name_nutzer;
        menge = row.menge_nutzer * arbeitstage;
        row.einheit = row.einheit_nutzer;
        row.value = (row.menge_nutzer && row.faktor_nutzer ? row.faktor_nutzer * row.menge_nutzer : row.menge_nutzer)
            * arbeitstage;
        row.faktor = row.faktor_nutzer ? row.faktor_nutzer * 1000000 : null;
        row.faktor_einheit = `gCO₂Äq/${row.einheit_nutzer || ''}`;
        row.quelle = `Eingabe durch Nutzer:in${row.quelle_nutzer ? ` / Quelle: ${row.quelle_nutzer}` : ''}`;
        row.mengeOrig = row.menge_nutzer;
        row.einheitOrig = row.einheit_nutzer;
        row.formel_co2 = 'co2_fahrt_arbeitstage';
        row.faktoren = [
            {
                value: fakt_hin_rueck,
                type: KennzahlFaktor.TYPE_FAHRT,
                formel: 'menge_fahrt'
            },
            {
                value: arbeitstage,
                type: KennzahlFaktor.TYPE_ARBEITSTAGE,
                formel: 'menge_fahrt_arbeitstage'
            }
        ];
        arr_datenqualitaet.push({
            wert: row.value,
            emissionsfaktor: +row.datenqualitaet_emissionsfaktor,
            datenherkunft: +row.datenherkunft,
            bewertung: +row.bewertung_emissionsfaktor
        });
    }
    // Übernachtungen
    if (row.uebernachtungen_anzahl > 0 && row.unterkunft) {
        const personen = row.personen || 1;
        const faktor_ueb = getCO2AequivalentSubscope69_Unterkunft(data, jahr, row.unterkunft);
        const value_ueb = +row.uebernachtungen_anzahl * +faktor_ueb.wert * personen;
        if (!row.value) {
            row.name = getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'unterkunft', row.unterkunft);
        }
        menge = row.uebernachtungen_anzahl;
        row.einheit = 'ÜN';
        row.value = (row.value || 0) + value_ueb;
        row.name = row.mitarbeiter + ': ' + row.name;
        row.faktor = +faktor_ueb.wert * 1000000;
        row.faktor_einheit = 'gCO₂Äq/ÜN';
        row.quelle = faktor_ueb.quelle;
        arr_datenqualitaet.push({
            wert: value_ueb,
            emissionsfaktor: +faktor_ueb.datenqualitaet,
            datenherkunft: +row.datenherkunft,
            bewertung: +row.bewertung_emissionsfaktor
        });
    }
    const key_items = 'co2_fussabdruck_s3_ss7_items';
    if (!item[key_items]) {
        item[key_items] = [];
    }
    // Datenqualität setzen
    row.datenqualitaet = getDatenqualitaet(arr_datenqualitaet);
    //  console.log('Scope 7: arr_datenqualitaet', row.datenqualitaet, arr_datenqualitaet, row.faktor_map);
    row.menge = menge;
    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + (row.value || 0);
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row.value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);

    //  console.log('SS7', row.faktor_map, row.name);
}
